/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Box, FormControl } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import ShortcutOutlinedIcon from "@mui/icons-material/ShortcutOutlined";
import { useDispatch, useSelector } from "react-redux";
import useSWRMutation from "swr/mutation";
import { useNavigate } from "react-router";
import { mutate } from "swr";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { isMobile } from "react-device-detect";

import CustomInput from "../../CustomInput";
import { fetcherPost } from "../../../../services/fetcher";
import {
  getSettingState,
  setAlertDialog,
  setAlertDialogData,
  setCmState,
  setReplyComment,
} from "../../../../redux/features/settingSlice";
import RightLeftChecker from "../../../../utils/RightLeftChecker";

const CommentGptInput = ({ profile, comment, setComment, conversRes }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { replyComment, cmState, userData } = useSelector(getSettingState);
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;

  useEffect(() => {
    const keyEnter = (event) => {
      if (event.key === "Enter" && !event.shiftKey && !!comment && !isMobile) {
        event.preventDefault();

        handleSubmit(event);
      }
    };
    document.addEventListener("keydown", keyEnter);

    return () => {
      document.removeEventListener("keydown", keyEnter);
    };
  }, [comment]);

  const closeReplyHandler = () => {
    dispatch(setReplyComment(null));
  };

  const handleLogin = () => {
    if (!userData) {
      dispatch(setAlertDialog(true));
      dispatch(
        setAlertDialogData({
          title: "You are not logged in!",
          dis: "You should log into your account to add a comment.",
          btn1: "Cancel",
          btn2: "Login",
          btn2Onclick: () => navigate("/login"),
        })
      );
    }
  };

  const {
    data: cmObject,
    trigger,
    isMutating,
  } = useSWRMutation(
    [process.env.REACT_APP_API + `/qa/message/`, tokenStorage],
    fetcherPost,
    {
      onSuccess: () => {
        setComment("");

        mutate(
          process.env.REACT_APP_API +
            `/qa/conversation/messages/${
              profile?.username
            }/?page=${1}&page_size=30`
        );
      },
      onError: (e) => {
        if (e.request.statusText === "Unauthorized") {
        }
      },
    }
  );

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (comment !== "\n") {
      try {
        await trigger({
          text: comment,
          conversation: conversRes,
        });
      } catch {}
    }
  };

  useEffect(() => {
    if (cmState && cmObject) {
      dispatch(setCmState([cmObject, ...cmState]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cmObject]);

  return (
    <Box
      sx={{
        backgroundColor: "white.main",
        position: "fixed",
        bottom: 0,
        width: "100%",
        zIndex: 4,
        borderTop: "2px solid",
        paddingTop: "5px",
      }}
    >
      {replyComment ? (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            paddingX: "22px",
          }}
        >
          <ShortcutOutlinedIcon
            sx={{
              width: "24px",
              height: "24px",
              color: "#757575",
              marginLeft: "6px",
            }}
          />
          <Box
            sx={{
              width: "2px",
              minHeight: "28px",
              backgroundColor: "secondary.main",
              borderRadius: "2px",
            }}
          />
          <Box sx={{ ml: "8px" }}>
            <Box
              sx={{
                fontWeight: 600,
                color: "secondary.main",
                fontSize: "12px",
              }}
            >
              {replyComment.author.nickname}
            </Box>
            <Box
              sx={{
                fontWeight: "400",
                fontSize: "12px",
                lineHeight: "14px",
                pr: "26px",
                direction: RightLeftChecker(replyComment.text) ? "rtl" : "ltr",
              }}
            >
              {replyComment.text}
            </Box>
          </Box>
          <Box
            sx={{
              position: "absolute",
              right: "22px",
              cursor: "pointer",
              color: "#757575",
              mt: "4px",
            }}
            onClick={closeReplyHandler}
          >
            <CloseRoundedIcon />
          </Box>
        </Box>
      ) : null}

      <Box
        onClick={handleLogin}
        sx={{
          width: "100%",
          maxHeight: "115px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingX: "16px",
        }}
      >
        <FormControl
          component={"form"}
          onSubmit={handleSubmit}
          sx={{
            m: 1,
            width: "100%",
          }}
        >
          <CustomInput
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            label='Add your comment'
            autoComplete
            multiline
            disabled={!userData}
            endIconClick={handleSubmit}
            endIconDisabled={comment === "" || isMutating}
            endIcon={
              <SendIcon
                sx={{ color: comment === "" ? "dark.main" : "textField.main" }}
              />
            }
          />
        </FormControl>
      </Box>
    </Box>
  );
};

export default CommentGptInput;
